export default "__VITE_ASSET__DJtGwzeu__"